import React, { useContext, useEffect, useState } from 'react';
import Title from '../../components/Title/Title';
import { Row, Col, message, Card, Input, Button, Select } from 'antd';
import { ADMIN_PROJECT, SUPERADMIN, updateUserSchema } from './schema';
import axios from '../../util/Api';
import { useHistory, Link } from 'react-router-dom';
import { ErrorMessage, Form, Formik } from 'formik';
import Item from '../../components/Form/Item';
import { ParamsContext } from '../Context/ParamsContext';
import ProjectSelect from './ProjectSelect';

const Update = (props) => {
  const history = useHistory();
  const { id } = useContext(ParamsContext);
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUserDetail();
  }, [id]);

  const fetchUserDetail = () => {
    setLoading(true);
    const url = `/user/detail?id=${id}`;
    axios.get(url).then(resp => {
      setUser(resp.data);
      setLoading(false);
    }).catch(err => {});
  }
  return (
    <>
      <Title>Perbarui User</Title>
      {loading ? "Sedang memuat..." : (
        <Row>
          <Col span={16}>
            <Formik
              initialValues={{
                name: user.name,
                email: user.email,
                status: user.status.id,
                password: '',
                confirm_password: '',
                role: user.role.id,
                project: user.project ? user.project.id : undefined,
              }}
              validationSchema={updateUserSchema}
              onSubmit={values => {
                const url = `/user/update?id=${user.id}`;
                axios.post(url, { ...values }).then(resp => {
                  message.success(`User ${resp.data.user.name} telah berhasil diperbarui`);
                  history.push(`/users/detail?id=${resp.data.user.id}`);
                }).catch(err => {
                  message.error('Gagal memperbarui user');
                });
              }}
            >
              {formik => (
                <Form>
                  <Card className="gx-card">
                    <Item name="Nama User" required>
                      <Input value={formik.values.name} name="name" onChange={formik.handleChange} />
                      <ErrorMessage component="div" name="name" className="gx-text-danger gx-text-sm" />
                    </Item>
                    <Item name="Email" required>
                      <Input value={formik.values.email} name="email" onChange={formik.handleChange} />
                      <ErrorMessage component="div" name="email" className="gx-text-danger gx-text-sm" />
                    </Item>
                    <Item name="Status" required>
                      <Select
                        name="status"
                        placeholder="Status user"
                        onChange={(value) => formik.setFieldValue("status", value)}
                        defaultValue={formik.values.status}
                      >
                        <Select.Option value={10}>Aktif</Select.Option>
                        <Select.Option value={9}>Tidak Aktif</Select.Option>
                      </Select>
                      <ErrorMessage component="div" name="status" className="gx-text-danger gx-text-sm" />
                    </Item>
                    {/* <Item name="Password">
                      <Input type="password" name="password" onChange={formik.handleChange} placeholder="Kosongkan jika tidak ingin mengganti password" />
                      <ErrorMessage component="div" name="password" className="gx-text-danger gx-text-sm" />
                    </Item>
                    <Item name="Konfirmasi Password">
                      <Input type="password" name="confirm_password" onChange={formik.handleChange} placeholder="Kosongkan jika tidak ingin mengganti password" />
                      <ErrorMessage component="div" name="confirm_password" className="gx-text-danger gx-text-sm" />
                    </Item> */}
                    <hr />
                    <Item name="Jenis User" required>
                      <Select
                        name="role"
                        onChange={(val) => formik.setFieldValue("role", val)}
                        defaultValue={formik.values.role}
                        style={{ width: 320 }}
                      >
                        <Select.Option value={SUPERADMIN}>Superadmin</Select.Option>
                        <Select.Option value={ADMIN_PROJECT}>Admin Proyek</Select.Option>
                      </Select>
                      <ErrorMessage component="div" name="role" className="gx-text-danger gx-text-sm" />
                    </Item>
                    {formik.values.role === ADMIN_PROJECT ? (
                      <Item name="Proyek" required>
                        <ProjectSelect />
                        <ErrorMessage component="div" name="project" className="gx-text-danger gx-text-sm" />
                      </Item>
                    ) : null}
                    <div className="m-t-15">
                      <Row>
                        <Col span={6}></Col>
                        <Col span={18}>
                          <Button type="primary" htmlType="submit" className="gx-mb-0" loading={formik.isSubmitting}>Simpan User</Button>
                          <Link to="/users" className="ant-btn ant-btn-secondary gx-mb-0">
                            Kembali
                          </Link>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      )}
    </>
  );
}

export default Update;